import { apiPaths } from '../config/apiPaths';
import { postJson } from '../postClient';

export const createConversationApi = (body, authHeaders) =>
  postJson(apiPaths.getConversation, body, authHeaders, {
    defaultError: 'Failed to create conversation',
  });
